<template>
  <div class="header">

    <LogoAni style="opacity: 0;"/>

    <div class="text-block">
      <!-- <p class="col1-5">Internet Architects</p> -->
      <div class="row lt">
        <p>Branding</p>
        <p>Design</p>
        <p>Development</p>
      </div>

      <!-- <div class="row rt">
        <div>
          <a href="mailto:niklaz@mesh-in.com" target="_blank" class="link">Email</a>
        </div>
        <div>
          <a href="https://www.instagram.com/mesh_innovation/" target="_blank" class="link">Instagram</a>
        </div>
        <div>
          <a href="https://www.linkedin.com/company/mesh-innovation/" target="_blank" class="link">Linked In</a>
        </div> 
      </div> -->

      <div class="row rt m-top">
        <router-link to="/about" class="link">About</router-link>
        <a href="#projects" class="link">Projects</a>
        <a href="#contact" class="link">Contact</a>
      </div>

      <!-- <div class="row ct">
        <p class="grey">{{ time }}</p>
      </div> -->



    </div>

      <div class="row ct m-top d-f fd-c jc-c ai-c tt-uc">
        <p>Selected Work</p>
        <div class="ani-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
        </div>
      </div>
  </div>
</template>

<script>
import LogoAni from '@/components/LogoAni.vue'

export default {
  name: 'Header',
  components: {
    LogoAni
  },
  data() {
    return {
      time: '',
    }
  },
  mounted() {
    this.startTime()
  },
  methods: {

    startTime() {
      var dt = new Date();
      dt.setTime(dt.getTime() + (60 * 60 * 2000));
      var h = dt.getUTCHours();       // Use UTC methods to get time
      var m = dt.getUTCMinutes();
      var s = dt.getUTCSeconds();
      h = this.checkTime(h)
      m = this.checkTime(m)
      s = this.checkTime(s)
      this.time = h + ":" + m + ":" + s
      setTimeout(this.startTime, 500)
    },
    checkTime(i) {
      if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
      return i;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";
@import "../scss/_classes.scss";

</style>
